import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, SlidersHorizontal, Search } from 'lucide-react';
import { useAsync } from '../lib/useAsync';
import { store } from '../lib/store';
import { useMembers } from '../lib/members';
import { IdCard } from 'lucide-react';
import { Chips, IconChip, ListRow, EmptyState, SkeletonList } from '../components/ui';
import { DOC_SIGLA } from '../lib/format';
import type { DocumentType } from '@shared/types';

type Filter = 'tutti' | DocumentType;

const FILTERS: { value: Filter; label: string }[] = [
  { value: 'tutti', label: 'Tutti' },
  { value: 'cie', label: 'CIE' },
  { value: 'patente', label: 'Patente' },
  { value: 'passaporto', label: 'Passap.' },
  { value: 'tessera_sanitaria', label: 'Tessera' },
];

export function DocumentiScreen() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<Filter>('tutti');
  const [q, setQ] = useState('');
  const { activeId } = useMembers();
  const { data, loading } = useAsync(
    () => store.documents({ type: filter, q, member_id: activeId ?? undefined }),
    [filter, q, activeId],
  );

  return (
    <div className="screen">
      <div className="topbar">
        <button className="iconbtn" onClick={() => navigate(-1)} aria-label="Indietro">
          <ChevronLeft size={20} />
        </button>
        <div className="topbar__title">Identità</div>
        <button className="iconbtn" aria-label="Filtri">
          <SlidersHorizontal size={18} />
        </button>
      </div>

      <div className="searchbar" style={{ marginBottom: 14 }}>
        <Search size={18} />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Cerca un documento…"
          aria-label="Cerca"
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <Chips options={FILTERS} active={filter} onChange={setFilter} />
      </div>

      {loading ? (
        <SkeletonList rows={4} />
      ) : data && data.length > 0 ? (
        <div className="list">
          {data.map((d) => (
            <ListRow
              key={d.id}
              chip={<IconChip>{DOC_SIGLA[d.type]}</IconChip>}
              title={d.title}
              meta={`${d.holder}${d.expires_at ? ` · scad. ${d.expires_at.slice(0, 4)}` : ''}`}
              onClick={() => navigate(`/documenti/${d.id}`)}
            />
          ))}
        </div>
      ) : (
        <EmptyState
          icon={<IdCard size={48} />}
          title="Il tuo archivio è vuoto"
          message="Aggiungi un documento per averlo sempre a portata di mano."
          cta={
            <button className="btn btn--accent" onClick={() => navigate('/nuovo')}>
              Aggiungi documento
            </button>
          }
        />
      )}
    </div>
  );
}
